import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

export type ListKey = 'contacts' | 'assignments';

/**
 * Remembers the last query params (paging, sort, filter) of a list so that
 * a detail view can navigate back to the list exactly where the user left it.
 * In-memory only: after a hard refresh the detail view falls back to the default list.
 */
@Injectable({ providedIn: 'root' })
export class ListQueryStateService {
  private readonly params = new Map<ListKey, Params>();

  /** Called by a list on init (from the URL) and after every URL write. */
  remember(listKey: ListKey, params: Params): void {
    this.params.set(listKey, { ...params });
  }

  /** Query params to attach when navigating back to the list; {} when unknown. */
  getQueryParams(listKey: ListKey): Params {
    return { ...(this.params.get(listKey) ?? {}) };
  }
}
